export const CustomerStep = ({ t, c, setC, a, setA }) => {
  const fc = (k) => (e) => setC({ ...c, [k]: e.target.value });
  const fa = (k) => (e) => setA({ ...a, [k]: e.target.value });
  return (
    <div className="space-y-3">
      <p className={t.label}>SEUS DADOS</p>
      <input data-testid="checkout-name-input" className={t.field} placeholder="Nome completo" value={c.name} onChange={fc("name")} required />
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <input data-testid="checkout-email-input" type="email" className={t.field} placeholder="E-mail" value={c.email} onChange={fc("email")} required />
        <input data-testid="checkout-phone-input" inputMode="tel" className={t.field} placeholder="Celular com DDD" value={c.phone} onChange={fc("phone")} required />
      </div>
      <input data-testid="checkout-cpf-input" inputMode="numeric" className={t.field} placeholder="CPF" value={c.cpf} onChange={fc("cpf")} required />
      <p className={`${t.label} pt-2`}>ENDEREÇO DE ENTREGA</p>
      <input data-testid="checkout-street-input" className={t.field} placeholder="Rua" value={a.street} onChange={fa("street")} required />
      <div className="grid grid-cols-3 gap-3">
        <input data-testid="checkout-number-input" className={t.field} placeholder="Nº" value={a.number} onChange={fa("number")} required />
        <input data-testid="checkout-complement-input" className={`${t.field} col-span-2`} placeholder="Complemento" value={a.complement} onChange={fa("complement")} />
      </div>
      <input data-testid="checkout-district-input" className={t.field} placeholder="Bairro" value={a.district} onChange={fa("district")} required />
      <p data-testid="checkout-city" className={`text-sm ${t.muted}`}>{a.city ? `${a.city} / ${a.state}` : "Cidade preenchida pelo CEP"}</p>
    </div>
  );
};
